import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { es } from "date-fns/locale";
import { format, parseISO } from "date-fns";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

function capitalize(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

function toIso(date) {
  return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, "0"), String(date.getDate()).padStart(2, "0")].join("-");
}

export function DateField({ label, value, onChange, testId, min, max, required = false, hint, clearable = false }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  const disabled = [];
  if (min) disabled.push({ before: parseISO(min) });
  if (max) disabled.push({ after: parseISO(max) });
  return (
    <div className="block">
      <span className="field-label">{label}</span>
      <input type="hidden" value={value || ""} required={required} readOnly data-testid={testId} />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" className={`h-12 w-full justify-start gap-3 rounded-none border-white/10 bg-charcoal px-4 font-normal text-slate-100 hover:border-clay/60 hover:bg-charcoal hover:text-clay ${!value ? "text-slate-500" : ""}`} data-testid={`${testId}-trigger`} aria-label={label}>
            <CalendarDays className="h-4 w-4 text-clay" />
            <span className="flex-1 truncate text-left" data-testid={`${testId}-display`}>{selected ? capitalize(format(selected, "EEEE d 'de' MMMM 'de' yyyy", { locale: es })) : "Elegir fecha"}</span>
            {clearable && value ? <X className="h-3.5 w-3.5 text-slate-500 hover:text-red-300" onClick={(event) => { event.stopPropagation(); onChange(""); }} data-testid={`${testId}-clear`} /> : null}
          </Button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-auto rounded-none border-white/15 bg-panel p-0 text-slate-100" data-testid={`${testId}-popover`}>
          <Calendar
            mode="single"
            locale={es}
            weekStartsOn={1}
            selected={selected}
            defaultMonth={selected || (max ? parseISO(max) : new Date())}
            disabled={disabled}
            onSelect={(date) => { if (date) { onChange(toIso(date)); setOpen(false); } }}
            initialFocus
          />
        </PopoverContent>
      </Popover>
      {hint ? <p className="mt-1 text-xs text-slate-500">{hint}</p> : null}
    </div>
  );
}
